import React from 'react';

import { Arrow, Line, Marker } from './Elements';

interface SpeedDialProps {
    speed: number | null;
    minSpeed: number | null;
    maxSpeed: number | null;
}

const RADIUS = 490;
const MIN_ANGLE_COLOR = '#0000FF';
const MAX_ANGLE_COLOR = '#FF0000';

const DIAL_TEXT_POSITIONS = [
    { value: 0, angle: 210, x: 280, y: 860 },
    { value: 10, angle: 240, x: 140, y: 730 },
    { value: 20, angle: 270, x: 80, y: 530 },
    { value: 30, angle: 300, x: 140, y: 330 },
    { value: 40, angle: 330, x: 260, y: 200 },
    { value: 50, angle: 0, x: 450, y: 150 },
    { value: 60, angle: 30, x: 650, y: 200 },
    { value: 70, angle: 60, x: 780, y: 330 },
    { value: 80, angle: 90, x: 830, y: 530 },
    { value: 90, angle: 120, x: 770, y: 730 },
    { value: 100, angle: 150, x: 620, y: 860 },
];

const getAngle = (speed: number) => 3 * speed - 150;

const SpeedDial: React.FC<SpeedDialProps> = ({ speed, minSpeed, maxSpeed }) => (
    <svg viewBox='0 0 1000 1000' preserveAspectRatio='xMinYMin meet' fontSize={80}>
        <circle fill='#EEE' stroke='#083461' strokeWidth={1} cx={500} cy={500} r={RADIUS} />

        {DIAL_TEXT_POSITIONS.map((item) => (
            <text key={item.value} fill='#083461' x={item.x} y={item.y}>
                {item.value}
            </text>
        ))}
        {DIAL_TEXT_POSITIONS.map((item) => (
            <Marker key={item.value} angle={item.angle} color='#083461' />
        ))}

        {typeof minSpeed === 'number' && <Line angle={getAngle(minSpeed)} color={MIN_ANGLE_COLOR} />}
        {typeof maxSpeed === 'number' && <Line angle={getAngle(maxSpeed)} color={MAX_ANGLE_COLOR} />}
        {typeof speed === 'number' && <Arrow angle={getAngle(speed)} />}
        <circle fill='black' strokeWidth={1} cx={500} cy={500} r={20} />
    </svg>
);

export default SpeedDial;
